import * as React from "react";
import { Link, useLocation } from "react-router";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import logo from "../../assets/logo-with-text.svg";
import { Calendar, LayoutDashboard, Mail, PlayCircle } from "lucide-react";

const data = {
  navMain: [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: <LayoutDashboard />,
    },
    {
      title: "Lessons",
      url: "/lessons",
      icon: <PlayCircle />,
    },
    {
      title: "Appointments",
      url: "/appointments",
      icon: <Calendar />,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const location = useLocation();

  return (
    <Sidebar variant="floating" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <Link to="https://amosinstitute.com">
              <img
                src={logo}
                alt="Amos Institute Logo"
                className="w-[95%] px-2 mt-1"
              />
            </Link>
            <hr className="my-3" />
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu className="gap-2">
            {data.navMain.map((item) => (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton asChild size="lg">
                  <Link
                    to={item.url}
                    className={`text-neutral-900 space-x-2 rounded-md px-2 py-1.5 transition-colors ${
                      location.pathname === item.url
                        ? "pointer-events-none bg-neutral-200 text-neutral-900"
                        : "hover:bg-neutral-50"
                    }`}
                  >
                    <span className="text-lg">{item.icon}</span>
                    <p className="text-lg tracking-tight">{item.title}</p>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
